import React from "react";
import Typography from "@material-ui/core/Typography";
import { Box, useTheme } from "@material-ui/core";

type Props = {
  title?: string;
};

const ProductDetailsContentModule: React.FunctionComponent<Props> = ({
  title,
  children
}) => {
  const theme = useTheme();
  return (
    <section data-testid="product-details.module">
      {title && (
        <Box
          display="flex"
          flexDirection="column"
          flex="0 1 auto"
          marginBottom={2.5}
          paddingBottom={1.5}
          borderBottom={`2px solid ${theme.palette.grey[400]}`}
          className="compact"
        >
          <Typography variant="h6" component="h2">
            {title}
          </Typography>
        </Box>
      )}
      {children}
    </section>
  );
};

export default ProductDetailsContentModule;
